import * as React from 'react';
import {
  LENGTH_DISPLAY_UNIT_MM,
  LENGTH_DISPLAY_UNIT_M,
  AREA_DISPLAY_UNIT_MM2,
  AREA_DISPLAY_UNIT_M2,
} from '../../utils/PlaceCodeDisplayUnits';

/** 項目名を押したときに選択欄へ移れるよう、ラベルと選択欄を結び付けるid。補修コードの入力画面に1つしか置かないので固定の値にする */
const LENGTH_SELECT_ID = 'PlaceCodeDisplayUnitInput-length';
const AREA_SELECT_ID = 'PlaceCodeDisplayUnitInput-area';

interface PlaceCodeDisplayUnitInputProps {
  lengthDisplayUnit: number;
  areaDisplayUnit: number;
  onChangeLengthDisplayUnit: (value: number) => void;
  onChangeAreaDisplayUnit: (value: number) => void;
}

export const PlaceCodeDisplayUnitInput: React.FC<PlaceCodeDisplayUnitInputProps> = function (
  props
) {
  return (
    <>
      <div className="App-input_container">
        <label className="App-label" htmlFor={LENGTH_SELECT_ID}>
          長さの表示単位
        </label>
        <select
          id={LENGTH_SELECT_ID}
          value={props.lengthDisplayUnit}
          onChange={(event) => {
            props.onChangeLengthDisplayUnit(Number(event.target.value));
          }}
        >
          <option value={LENGTH_DISPLAY_UNIT_MM}>㎜</option>
          <option value={LENGTH_DISPLAY_UNIT_M}>m</option>
        </select>
      </div>
      <div className="App-input_container">
        <label className="App-label" htmlFor={AREA_SELECT_ID}>
          面積の表示単位
        </label>
        <select
          id={AREA_SELECT_ID}
          value={props.areaDisplayUnit}
          onChange={(event) => {
            props.onChangeAreaDisplayUnit(Number(event.target.value));
          }}
        >
          <option value={AREA_DISPLAY_UNIT_MM2}>㎟</option>
          <option value={AREA_DISPLAY_UNIT_M2}>㎡</option>
        </select>
      </div>
    </>
  );
};
